import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-confirmation-button',
  templateUrl: './confirmation-button.component.html',
  styleUrls: ['./confirmation-button.component.scss']
})
export class ConfirmationButtonComponent implements OnInit, OnDestroy {
  public buttonText = '';
  public confirmText = 'Confirm?';
  public showConfirmation = false;
  public showResultContainer = false;
  public status = '';
  public timer: any = 0;


  @Input() text: string;
  @Input() isPledge = false;
  @Input() confirmSubText = 'Pledge of $1000';
  @Output() onConfirm: EventEmitter<any> = new EventEmitter();
  @Output() onCancel: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {
    this.buttonText = this.text;
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  onClick(event) {
    event.stopPropagation();
    if (this.showConfirmation || this.timer) {
      return;
    }

    this.showConfirmation = !this.showConfirmation;

    if (this.showConfirmation) {
      this.buttonText = this.confirmText;
    }
  }

  confirm(event) {
    event.stopPropagation();

    if (this.timer) { return; }

    this.status = 'confirmed';
    this.buttonText = 'Thank you!';

    this.timer = setTimeout(() => {
      clearTimeout(this.timer);
      this.resetData();
      this.onConfirm.emit(true);
    }, 1000);
  }

  cancel(event) {
    event.stopPropagation();

    if (this.timer) { return; }

    this.status = 'canceled';
    this.buttonText = 'Pledge canceled.';

    this.timer = setTimeout(() => {
      clearTimeout(this.timer);
      this.resetData();
      this.onCancel.emit(false);
    }, 1000);
  }

  resetData() {
    this.status = '';
    this.showConfirmation = false;
    this.showResultContainer = false;
    this.buttonText = this.text;
    this.timer = 0;
  }
}
